import { AxiosResponse } from "axios";
import { request } from "../../../utils";
import { SyncResponse } from "../../../types";

export const getAllSync = (opts?: {
  signal?: AbortSignal;
}): Promise<AxiosResponse<SyncResponse>> => {
  const req = request();
  return req.get("/api/v1/storage-commander/sync", {
    signal: opts?.signal,
  });
};
